import axiosInstance from '@/core/api'
import type { components } from '@/schema'

type RankExperienceSettingModel =
	components['schemas']['RankExperienceSettingModel']
type UpdateRankExperienceSettingDto =
	components['schemas']['UpdateRankExperienceSettingDto']

export class RankExperienceService {
	static async getRankExperienceSetting(): Promise<RankExperienceSettingModel> {
		const { data } = await axiosInstance.get<RankExperienceSettingModel>(
			'/admin/operators/ranks/experience-setting',
		)
		return data
	}

	static async updateRankExperienceSetting(
		body: UpdateRankExperienceSettingDto,
	): Promise<RankExperienceSettingModel> {
		const { data } = await axiosInstance.patch<RankExperienceSettingModel>(
			'/admin/operators/ranks/experience-setting',
			body,
		)
		return data
	}
}
